import { ProgressBar } from '../progress-bar';
import * as styles from './index.css';
import { Flex, Icon, Text } from '@customerio/pluma-components/react';

export function SetupGuideCard({ progress }: { progress: number }) {
  return (
    <>
      <Flex>
        <Icon name="setup-guide" size="md" mr="075" />
        <div className={styles.setupGuideNavHeaderTitle}>Setup Guide</div>
      </Flex>
      <ProgressBar progress={progress} />
      <Text size="xs" weight="regular">
        Finish setting up your workspace so you can start sending messages.
      </Text>
    </>
  );
}
